(function () {
  var COOKIE_NAME = 'skullpot_geo_dismissed';

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function init() {
    var banner = document.getElementById('skullpot-geo-banner');
    if (!banner) return;
    if (getCookie(COOKIE_NAME)) return;

    var currentCountry = banner.getAttribute('data-current-country');
    var countryList = banner.querySelectorAll('#skullpot-geo-countries-data li');
    var countries = {};
    countryList.forEach(function (li) {
      countries[li.getAttribute('data-iso')] = {
        name: li.getAttribute('data-name'),
        currency: li.getAttribute('data-currency')
      };
    });

    fetch('https://ipapi.co/country/', { cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('geo lookup failed');
        return response.text();
      })
      .then(function (isoCode) {
        isoCode = (isoCode || '').trim().toUpperCase();
        if (!isoCode || isoCode === currentCountry) return;
        var match = countries[isoCode];
        if (!match) return;

        var textEl = document.getElementById('skullpot-geo-text');
        var codeInput = document.getElementById('GeoCountryCode');
        if (textEl) {
          textEl.textContent = 'Sieht so aus, als wärst du in ' + match.name + '. Möchtest du zu ' + match.name + ' (' + match.currency + ') wechseln?';
        }
        if (codeInput) codeInput.value = isoCode;

        banner.hidden = false;
        requestAnimationFrame(function () {
          banner.classList.add('skullpot-geo-banner--visible');
        });
      })
      .catch(function () {
        /* Geolocation-Dienst nicht erreichbar - Banner bleibt ausgeblendet */
      });

    var dismissBtn = banner.querySelector('.skullpot-geo-banner__dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        setCookie(COOKIE_NAME, '1', 30);
        banner.classList.remove('skullpot-geo-banner--visible');
        setTimeout(function () {
          banner.hidden = true;
        }, 400);
      });
    }

    var form = banner.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        setCookie(COOKIE_NAME, '1', 365);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
